import Grid from '../components/Grid';
import { AttachmentInput, GroupInput, Input, TextInput } from '../components/Input';

const yup = require('../interface/yup-br');

export const LicitaoIA = () => {
    return (
        <Grid
            url={'/licitaia'}
            perms={'110'}
            disableModal={true}
            GridHeaders={
                [
                    { title: 'Contratante', field: 'Contratante', sort: true, className: 'w-1/4' },
                    { title: 'Cidade', field: 'cidade', sort: true, className: 'w-1/4 text-left pl-1' },
                    { title: 'Edital número', field: 'numero', type: 'date', sort: true, className: 'w-1/4' },
                    {
                        title: 'Arquivo',
                        field: 'arquivo',
                        sort: true,
                        className: 'w-1/4 pl-1 text-left border-l border-gray-300',
                    },

                ]}
            GridTitle="Plataformas de operação"
            LineDataPrint={(data) => {
                return [
                    data.contratante,
                    data.cidade,
                    data.numero,
                    `#link=${data.arquivo}|view=${data.arquivo}`

                ];
            }}
            onRenderForm={(GridModes, SetFieldValue, values) => {
                localStorage.setItem('autoEdit', null);
                return (
                    <>
                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                            <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                        </div>
                        {GridModes.insert_mode ? (
                            <div className='p-2'>
                                <GroupInput>
                                    <AttachmentInput name="arquivo" accept="application/pdf" label="Arquivo PDF Edital" />
                                </GroupInput>
                            </div>
                        ) : (
                            <div className='p-2'>
                                <GroupInput>
                                    <Input name="contratante" label="Contratante" />
                                    <Input name="cidade" label="Cidade" />
                                </GroupInput >
                                <Input name="uasg" label="Código UASG" />
                                <GroupInput>
                                </GroupInput >
                                <GroupInput>
                                    <TextInput name="objeto" label="Objeto do edital" rows={'3'} />
                                </GroupInput >
                                <GroupInput>
                                    <Input name="numero" label="Edital número" />
                                    <Input name="identificacao" label="Identificação" />
                                </GroupInput>
                                <GroupInput>
                                    <Input name="modalidade" label="Modalidade" />
                                    <TextInput name="resumo" label="Resumo" rows={'5'} />
                                </GroupInput>
                                <GroupInput>
                                    <TextInput name="retornoIA" label="Resposta completa da IA" rows={'12'} />
                                </GroupInput>
                            </div >
                        )}
                    </>
                );
            }}
            validationSchema={
                yup.object().shape({
                    arquivo: yup.string().required('Arquivo obrigatório'),
                })
            }
        />

    );
}